/** Public company job cards show New when first published within this window. */
export const PUBLIC_OPEN_ROLE_NEW_WINDOW_MS = 3 * 24 * 60 * 60 * 1000

export function isPublicOpenRoleNew(
  publishedAtIso: string | null | undefined,
  nowMs = Date.now(),
): boolean {
  if (!publishedAtIso?.trim()) return false
  const publishedAt = new Date(publishedAtIso).getTime()
  if (Number.isNaN(publishedAt)) return false
  return nowMs - publishedAt < PUBLIC_OPEN_ROLE_NEW_WINDOW_MS
}
